import api from "../utils/axiosInstance";
import { GET_TICKETS, GET_TICKETS_ERROR, GET_TICKETS_REQUEST, UPDATE_TICKETS_DATA, REMOVE_TICKETS_DATA, GET_TICKET_TYPE, GET_TICKET_TYPE_ERROR, GET_TICKET_TYPE_REQUEST, UPDATE_TICKET_TYPE_DATA, REMOVE_TICKET_TYPE_DATA } from "../ActionTypes/ActionTypes.js";


const getAllTicketsRequest = () => ({ type: GET_TICKETS_REQUEST });
const getAllTicketsSuccess = (data) => ({ type: GET_TICKETS, payload: data });
const getAllTicketsError = (error) => ({ type: GET_TICKETS_ERROR, payload: error });

const getAllTicketTypeRequest = () => ({ type: GET_TICKET_TYPE_REQUEST });
const getAllTicketTypeSuccess = (data) => ({ type: GET_TICKET_TYPE, payload: data });
const getAllTicketTypeError = (error) => ({ type: GET_TICKET_TYPE_ERROR, payload: error });

export const getAllTicketList = (data) => async (dispatch) => {
    dispatch(getAllTicketsRequest());
    try {

        const response = await api.post(`/support/gettickets`, data);

        if (response.data.success) {
            dispatch(getAllTicketsSuccess(response.data));

        }
        else {
            dispatch(getAllTicketsError(response?.data?.message));
        }



    } catch (error) {
        dispatch(getAllTicketsError(error.response?.data?.message || error.message));
    }
};

export const updateTicketData = (newData) => ({
    type: UPDATE_TICKETS_DATA,
    payload: newData,
});


export const removeTicketDataData = (newData) => ({
    type: REMOVE_TICKETS_DATA,
    payload: newData,
});


export const getAllTicketTypeList = (data) => async (dispatch) => {
    dispatch(getAllTicketTypeRequest());
    try {
        const response = await api.post(`/support/gettickettype`, data);
        if (response.data.success) {
            dispatch(getAllTicketTypeSuccess(response.data));
        }
        else {
            dispatch(getAllTicketTypeError(response?.data?.message));
        }
    } catch (error) {
        dispatch(getAllTicketTypeError(error.response?.data?.message || error.message));
    }
};

export const updateTicketTypeData = (newData) => ({
    type: UPDATE_TICKET_TYPE_DATA,
    payload: newData,
});


export const removeTicketTypeData = (newData) => ({
    type: REMOVE_TICKET_TYPE_DATA,
    payload: newData,
});
